import React, { useEffect, useState } from 'react';
import { STEPS } from '../../utils/constants/progressSteps';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import { trackEvent, trackPageView } from '../../utils/tracking';
import { useFriendContext } from '../../utils/ContextProviders/FriendContext';
import { postSendVerificationPhoneCode, postVerifyPhoneCode } from '../../utils/Data/registerConnector';
import EditModal from './EditModal';
import { validateValidationCode } from './utilities/VerifyUtilities';
import VerificationInput from './VerificationInput';
import styles from './Verify.module.scss';
import { useVerifyUserFlowLocation } from '../../hooks/useVerifyUserFlowLocation';

function Verify() {
  const { goToStep } = useAppContext();
  const { friend, setFriend } = useFriendContext();
  const { verifyUserFlowLocation } = useVerifyUserFlowLocation();

  useEffect(() => {
    verifyUserFlowLocation();
    trackPageView(window.location.pathname);
  }, []);

  const [isDisable, setIsDisable] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationCodeError, setVerificationCodeError] = useState('');

  const handleChange = (value: string) => {
    setVerificationCode(value);
  };

  const resetInputError = () => {
    if (verificationCodeError !== '') {
      setVerificationCodeError('');
    }
  };

  const handleResend = () => {
    setIsDisable(true);
    postSendVerificationPhoneCode(friend?.phoneNumber).then(() => {
      setIsDisable(false);
    });
  };

  const handleVerify = () => {
    setIsDisable(true);
    postVerifyPhoneCode(friend?.phoneNumber, verificationCode).then((response) => {
      if (response?.data?.info?.status === 'approved') {
        goToStep(STEPS.PERSONAL_INFO);
        setFriend({ ...friend, isPhoneValidated: true });
        trackEvent('Phone Verified', friend, 'VERIFY', undefined, undefined);
      } else {
        setVerificationCodeError('Invalid verification code.');
      }
      setIsDisable(false);
    });
  };

  const handleUpdatePhoneNumber = (phoneNumber: string) => {
    setFriend({ ...friend, phoneNumber });
    setIsModalOpen(false);
    postSendVerificationPhoneCode(phoneNumber);
  };

  return (
    <section className={styles.verify}>
      <h2>Verify Mobile Phone</h2>
      <p>
        We’ve texted the verification code to
        {' '}
        <span>{friend?.phoneNumber?.replace(/_/g, '')}</span>
        .
      </p>
      <VerificationInput
        label="Verification Code"
        value={verificationCode}
        placeholder="Enter verification code"
        onChange={handleChange}
        onResend={handleResend}
        errorMessage={verificationCodeError}
        resetInputError={resetInputError}
      />
      <button
        type="button"
        className={styles.button}
        onClick={handleVerify}
        disabled={isDisable || !validateValidationCode(verificationCode)}
      >
        VERIFY
      </button>
      <button
        type="button"
        className={styles.editPhone}
        onClick={() => setIsModalOpen(true)}
      >
        Edit Mobile Phone Number
      </button>
      {isModalOpen && (
        <EditModal
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleUpdatePhoneNumber}
          phoneNumber={friend?.phoneNumber}
          countryCode={friend?.countryCode}
        />
      )}
    </section>
  );
}

export default Verify;
